import * as React from 'react';
import { useLocation } from 'react-router-dom';
import Layout from '../Layout/Layout';
import { useProfileVersion } from '../Vendors/profileVersion';

export default function Directory() {
  const location = useLocation();
  const { showV2 } = useProfileVersion();
  // The full-bleed sub-nav shell is a v2 treatment; v1 keeps the classic heading and
  // padded layout (matching the original profile). Only the v2 company profile drops
  // the heading and goes full-bleed. The list always keeps the heading.
  const useShell = /^\/registry\/.+/.test(location.pathname) && showV2;
  return (
    <Layout
      pageTitle='Company Registry'
      includeHeader={!useShell}
      includeDivider={!useShell}
      fullBleed={useShell}
    >
    </Layout>
  );
}
